module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('h1', {
    staticClass: "partner-heading"
  }, [_vm._v("The world's best choose us")]), _vm._v(" "), _c('span', {
    staticClass: "partner-logos"
  }, _vm._l((_vm.keyPartnerList), function(partner) {
    return _c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(partner),
        "alt": "partner"
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2d574d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/PartnersHero/PartnersHero.vue
// module id = 455
// module chunks = 0